import { render, staticRenderFns } from "./LocaleSelect.vue?vue&type=template&id=2d918958&scoped=true"
import script from "./LocaleSelect.vue?vue&type=script&lang=js"
export * from "./LocaleSelect.vue?vue&type=script&lang=js"
import style0 from "./LocaleSelect.vue?vue&type=style&index=0&id=2d918958&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d918958",
  null
  
)

export default component.exports